module.exports = __webpack_public_path__ + "img/diferente.ca7c9008.svg";